<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-5">
        <div class="col-12 text-right p-4 pb-2">
          <span class="ft12">CD,
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }},
            </span>
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.estado_cliente }}
            </span>
            a
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}.
            </span>
          </span>
        </div>
        <div class="col-12 pt-1 pb-1">
          <span class="ft12Black">
            GPI AUTO COMERCIAL SAPI DE C.V.
          </span>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft12">
            Por medio del presente les informo que el vehículo, que sirve como
            garantía prendaria del crédito celebrado con ustedes con fecha a,
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.fecha_contrato }}
            </span>
            y con las siguientes características:
          </span>
        </div>
        <div class="col-12 text-center pt-3 px-4">
          <span class="ft12">
            <span class="ft12Black">Marca</span>
            <span v-bind:class="{ marca: data.showMarca }" class="ft10">
              {{ data.marca_vehiculo }} </span
            >
            <span class="ft12Black">Modelo </span>
            <span v-bind:class="{ marca: data.showMarca }" class="ft10">
              {{ data.modelo_vehiculo }} </span
            >
            <span class="ft12Black">Año</span>
            <span v-bind:class="{ marca: data.showMarca }" class="ft10">
              {{ data.año_vehiculo }} </span
            >
            <span class="ft12Black">No Serie</span>
            <span v-bind:class="{ marca: data.showMarca }" class="ft10">
              {{ data.numero_serie_vehiculo }} </span
            >
            <!-- <span class="ft12Black">Placas</span>
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.placa_vehiculo }} </span
            >, -->
          </span>
        </div>
        <div class="col-12 text-justify pt-3 ">
          <span class="ft12">
            fue elegido por un servidor y fue revisado a mi entera satisfacción,
            así mismo he revisado la documentación que lo ampara y se encuentra
            en orden, específicamente:
            <br /><br />
            <div class="col-12 text-justify pr-3 ">
              • Factura original que ampara la unidad y que me da la posesión de
              esta.
              <br />
              • Consecutivo de facturas anteriores, que inicia con la factura de
              origen y termina con la que me da a posesión.
              <br />
              • Pagos de impuestos respectivos.
              <br /><br />
              Señalo que la unidad descrita anteriormente está en mi poder y
              uso. Así mismo, ratifico que entrego a GPI AUTO COMERCIAL SAPI DE C.V.
              la factura que acredita la propiedad, para que ésta quede como
              garantía del financiamiento recibido; si requieren algún otro
              documento relativo a la unidad podrá ser requerido por parte de
              GPI AUTO COMERCIAL SAPI DE C.V. para actualizar el expediente.
            </div>
            <br />
            Los documentos relativos al vehículo que ustedes tienen en su poder
            son los siguientes
            <br /><br />
            <div class="col-12 text-justify pr-3 ">
              A) <u class="ft12Black">Factura original</u> con su endoso,
              entregada en garantía a GPI AUTO COMERCIAL SAPI DE C.V.
              <br />
              B) <span class="ft12Black">Copia fotostática</span> de los
              consecutivos de Facturas con sus respectivos endosos.
              <br />
              C) <span class="ft12Black">Copia fotostática</span> del Pago de
              Impuestos de acuerdo con el o los estados donde se ha emplacado la
              unidad descrita (al menos los 5 últimos pagos de refrendo,
              tenencias, revista o impuestos que correspondan de acuerdo con la
              entidad estatal que emitió placas).
            </div>
            <br />
            <br />
            Así mismo, me comprometo a
            <u class="ft12">realizar el cambio de propietario</u> con los costos
            que este genere por mi cuenta y tener el vehículo al corriente en el
            pago de impuestos e infracciones que pudiesen darse en la
            recaudadora que me corresponde.
            <br />
            <br />
            Es mi responsabilidad mantener el vehículo en la situación
            administrativa correcta y al corriente de pagos que genera la
            entidad donde este registrado el vehículo.
            <br />
            <br />
            Cabe mencionar que en caso de presentar algún siniestro el automóvil
            durante la vida del crédito, estoy enterado que los tramites
            administrativos para presentar la documentación al seguro son mi
            responsabilidad y que
            <u class="ft12">el único documento original</u> en poder de GPI Auto
            Comercial es la factura que ampara mi propiedad, por lo que los
            pagos de impuestos, baja vehicular y trámites administrativos que se
            requieran serán hechos en los lugares que se requieran por parte de
            un servidor.
            <br /><br />
            El(Los) BIEN(ES) dado(s) en prenda quedara(n) en poder de
            ¨ACREDITADO¨ , a quien se considerara para los fines de su
            responsabilidad civil y penal como depositario judicial del(los)
            mismo(s),aceptando el desempeño de dicho cargo a título gratuito y
            obligándose a mantener dicho(s) BIEN(ES) a disposición del
            ¨ACREDITANTE¨.
            <br /><br />
            Con independencia a lo anterior, acuerdo dar cumplimiento a las
            obligaciones derivadas del contrato referido.

            <div class="col-12 text-justify pr-3 ">
              <br />
              Estoy consciente de que
              <u class="ft12"
                >el financiamiento recibido es independiente del vehículo por mi
                elegido</u
              >, por lo que, si éste tuviera algún problema la obligación para
              cubrir el financiamiento con GPI persiste.
            </div>
          </span>
        </div>
        <div class="col-12 row pt-4 pb-5">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center">
            <span class="ft13">
              A T E N T A M E N T E
              <br /><br />
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.nombre_cliente }}
              </span>
              <br /><br />
              <span class="ft13Black">NOMBRE DEL CLIENTE</span>
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/CartaInformeCliente.vue